import {ReportsDatasource} from "../../../data/datasources/reports-datasource";
import {makeAuthorizeHttpClientDecorator} from "../decorators/authorize-http-client-decorator-factory";

export const makeReportsDatasource = () => new ReportsDatasource(makeAuthorizeHttpClientDecorator())